import { getInitialPathByUserRole } from "../../utils/auth";
import axiosInstance from "../interceptor";

const api = `${getInitialPathByUserRole()}/business-unit`;

export const getBusinessUnitsWbs = () => axiosInstance.get(`${api}/wbs`);
export const getBusinessUnitsUser = () => axiosInstance.get(`${api}/user`);
